import {
  deleteConditionFilter,
  deleteConditionFromIfElse,
  updateActiveConditionId,
  updateFlowCondition,
} from '../../../../redux/Calculations/CalculationsActions';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useDispatch, useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ListItem } from '@mui/material';
import { useMemo, useState } from 'react';
import { ICalculationStep } from '../../../../redux/Calculations/CurrentCalculationSessionInterface';
import { MenuItem, Select, Tooltip } from '@mui/material';
import ConditionName from './ConditionName';
import { NotificationDialog } from '../../../CommonFunctions/DialogComponents';
import { fontSize, palette } from '../../../..';
import { isFlowUsed } from '../../utils';
import { RootState } from '../../../../redux';
import { useViewport } from '@xyflow/react';
const Condition = ({
  condition,
  propKey,
  index,
}: {
  condition: ICalculationStep;
  index: number;
  propKey: string;
}) => {
  const [openAlert, setOpenAlert] = useState(false);
  const { zoom } = useViewport();
  const allConditionTypes = useMemo(() => {
    return ['If', 'Else If', 'Else'];
  }, []);
  const dispatch = useDispatch();
  const currentCalculationSession = useSelector(
    (state: RootState) => state.calculations.properties[propKey]?.currentCalculationSession,
  );

  if (!currentCalculationSession) return null;

  const activeCondition = currentCalculationSession.activeCondition;

  const activeFlow = currentCalculationSession.activeFlow!;
  const activeFlowConditions: ICalculationStep[] =
    currentCalculationSession.calculationInfo.flows[activeFlow!];
  const calculationInfo = currentCalculationSession.calculationInfo;

  const handleDeleteCondition = (e: any, condition: ICalculationStep) => {
    e.stopPropagation();
    if (!activeFlow) return;
    const ifCount = activeFlowConditions.filter(
      (_condition) => _condition.condition === 'if',
    ).length;
    if (ifCount === 1 && condition.condition === 'if') setOpenAlert(true);
    else {
      dispatch(deleteConditionFromIfElse(propKey, activeFlow, condition.flowId));
      dispatch(deleteConditionFilter(propKey, condition.filter ?? ''));
    }
  };
  const safeToModifyCondition = (
    changeToConditionType: string,
    currConditionType: string,
    currIdx: number,
  ): boolean => {
    if (currConditionType === '') return false;
    changeToConditionType =
      changeToConditionType === 'If'
        ? 'if'
        : changeToConditionType === 'Else If'
          ? 'elseIf'
          : 'else';
    if (currConditionType === 'ElseIf') {
      currConditionType = 'Else If';
    }
    /**
     * if we change to same condition type then it is safe
     */
    if (currConditionType === changeToConditionType) return true;

    const totalConditionsCopunt = activeFlowConditions.length;

    if (currConditionType === 'if') {
      return false;
    } else if (currConditionType === 'elseIf') {
      /**
       * if currewnt condition is "else if" then  its safe to assume  that there is atleast one "if" condition
       *
       * and above "else if" there is only "if" condition or "else if" condition
       *
       */
      if (changeToConditionType === 'else') {
        const nextCondition = activeFlowConditions[currIdx + 1];
        if (!nextCondition) return true;
      }
    } else {
      if (changeToConditionType === 'elseIf') return true;
    }
    return false;
  };

  const flows = Object.keys(currentCalculationSession.calculationInfo.flows);

  return (
    <ListItem
      key={index}
      sx={{
        border: activeCondition === index ? '1px solid #2BBDCF' : '1px solid grey',
        borderRadius: '5px',
        marginBlock: '10px',
        padding: '0.3rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '1.5rem',
        width: '100%',
        cursor: activeCondition === index ? 'default' : 'pointer',
      }}
      onClick={(e) => {
        dispatch(updateActiveConditionId(propKey, index));
      }}
    >
      {isFlowUsed(flows, calculationInfo.flows, activeFlow, calculationInfo) ? (
        <Tooltip
          title="This calculation is being used in another flow. Please remove the dependency before deleting."
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <LockOutlinedIcon
            style={{
              color: '#2BB9BB',
            }}
          />
        </Tooltip>
      ) : (
        <CloseRoundedIcon
          onClick={(e) => {
            const activeFlow = currentCalculationSession.activeFlow;
            if (!activeFlow) return;
            const flows = Object.keys(currentCalculationSession.calculationInfo.flows);

            if (!isFlowUsed(flows, calculationInfo.flows, activeFlow, calculationInfo)) {
              handleDeleteCondition(e, condition);
            }
          }}
          sx={{
            fontSize: fontSize.medium,
            cursor: 'pointer',
            marginRight: '0.5rem',
            color: palette.primary.contrastText,
            '&:hover': {
              color: 'red',
              transform: 'scale(1.1)',
            },
          }}
        />
      )}
      <ConditionName
        conditionName={condition.conditionName}
        propKey={propKey}
        flowId={activeFlow!}
        conditionUid={condition.flowId}
        index={index}
        activeCondition={activeCondition!}
      />
      <Select
        value={
          condition.condition === 'if'
            ? 'If'
            : condition.condition === 'elseIf'
              ? 'Else If'
              : 'Else'
        }
        onChange={(e) => {
          if (
            isFlowUsed(
              Object.keys(calculationInfo.flows),
              calculationInfo.flows,
              activeFlow!,
              calculationInfo,
            )
          )
            return;
          const updatedCondition =
            e.target.value === 'If' ? 'if' : e.target.value === 'Else If' ? 'elseIf' : 'else';
          dispatch(updateFlowCondition(propKey, activeFlow!, index, updatedCondition));
        }}
        sx={{
          marginLeft: 'auto',
          height: '1.5rem',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          textAlign: 'left',
          '.MuiSelect-icon': {
            fontSize: '19px',
            marginLeft: '20px',
            color: palette.primary.contrastText,
            right: '3.5px',
          },
          fontSize: fontSize.medium,
        }}
        IconComponent={KeyboardArrowDownIcon}
        MenuProps={{
          slotProps: {
            paper: {
              sx: {
                transform: `scale(${zoom}) !important`
              }
            }
          },
        }}
      >
        {allConditionTypes.map((conditionType: string, _index: number) => {
          return (
            <MenuItem
              disabled={!safeToModifyCondition(conditionType, condition.condition ?? '', index)}
              sx={{ fontSize: fontSize.small, color: 'primary.contrastText', height: '1.5rem' }}
              key={_index}
              value={conditionType}
            >
              {conditionType}
            </MenuItem>
          );
        })}
      </Select>
      <NotificationDialog
        severity="warning"
        testMessage="Cannot delete the condition"
        openAlert={openAlert}
        onCloseAlert={() => {
          setOpenAlert(false);
        }}
      />
    </ListItem>
  );
};

export default Condition;
